import React from "react";
import {
  FaUserShield,
  FaMoneyBillWave,
  FaChartLine,
  FaUsers,
  FaClipboardCheck,
  FaCheckCircle,
} from "react-icons/fa";
const ruleCards = [
  {
    title: "General Rules",
    icon: <FaUserShield />,
    points: [
      "Students must come to school in neat, clean & tidy uniform on time.",
      "Good behaviour and observance of school rules are essential.",
      "No shouting, whistling, bullying or abusive language is allowed.",
      "Mobile phones and expensive jewellery are strictly prohibited.",
    ],
  },
  {
    title: "Fee Rule",
    icon: <FaMoneyBillWave />,
    points: [
      "Fee should be paid on or before 10th of every month.",
      "Late fee will be charged after the due date.",
      "No student will appear in exams unless dues are cleared.",
      "School fee once paid will not be refunded.",
    ],
  },
  {
    title: "Promotion Rule",
    icon: <FaChartLine />,
    points: [
      "Promotion depends on overall academic performance.",
      "Unfair means during tests may lead to strict action.",
      "Medical certificate is required for absence during exams.",
      "Principal’s decision will be final and binding.",
    ],
  },
  {
    title: "Guardian Recommendations",
    icon: <FaUsers />,
    points: [
      "Parents should check the school almanac regularly.",
      "Encourage balanced interest in studies, sports and activities.",
      "Avoid junk food and excess pocket money.",
      "Regular English conversation at home is helpful.",
    ],
  },
  {
    title: "Assessment Rule",
    icon: <FaClipboardCheck />,
    points: [
      "Minimum 75% attendance is required for annual assessment.",
      "Students are evaluated through unit tests and assessments.",
      "Grades are awarded as per CBSE norms.",
      "Overall performance decides promotion to higher class.",
    ],
  },
];

const RulesSection = () => {
  return (
    <section className="relative py-20 px-4 md:px-8 bg-gradient-to-br from-orange-50 via-white to-red-50 overflow-hidden">
      <div className="absolute top-0 left-0 w-72 h-72 bg-orange-300/20 rounded-full blur-3xl -translate-x-24"></div>
      <div className="absolute bottom-0 right-0 w-72 h-72 bg-red-300/20 rounded-full blur-3xl translate-x-24"></div>
      <div className="relative max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-5 py-2 text-sm font-semibold text-red-600 bg-red-100 rounded-full mb-4">
            School Guidelines
          </span>
          <h2 className="text-3xl md:text-5xl font-extrabold text-gray-900">
            Rules &{" "}
            <span className="bg-gradient-to-r from-red-600 to-orange-500 bg-clip-text text-transparent">
              Regulations
            </span>
          </h2>
          <p className="text-gray-600 mt-4 max-w-2xl mx-auto leading-7">
            Important conduct, discipline, fee, promotion and assessment rules
            for students and guardians.
          </p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-[0.9fr_1.1fr] gap-8 items-stretch">
          <div className="bg-gradient-to-br from-red-600 to-orange-500 rounded-[32px] p-7 md:p-10 text-white shadow-2xl flex flex-col justify-between">
            <div>
              <h3 className="text-3xl md:text-4xl font-extrabold leading-tight mb-5">
                We Can’t Spell Success Without “U”
              </h3>
              <p className="text-white/90 leading-8 mb-7">
                Discipline, regularity, respect and cooperation between school,
                students and guardians help every child grow with confidence and
                responsibility.
              </p>
              <div className="space-y-4">
                {[
                  "Neat & tidy uniform",
                  "Respect school property",
                  "Maintain discipline",
                  "Follow exam rules",
                  "Clear fee dues on time",
                ].map((item, index) => (
                  <div
                    key={index}
                    className="flex items-center gap-3 bg-white/15 border border-white/20 rounded-2xl p-4"
                  >
                    <FaCheckCircle className="text-yellow-200 shrink-0" />
                    <span className="font-semibold text-sm">{item}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className="mt-8 bg-white/10 border border-white/20 rounded-2xl p-5">
              <p className="text-sm leading-7 italic">
                “Ignorance of rules will not be an excuse.”
              </p>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {ruleCards.map((item, index) => (
              <div
                key={index}
                className={`bg-white rounded-[26px] p-6 shadow-xl border border-orange-100 hover:-translate-y-1 hover:shadow-2xl transition-all duration-300 ${
                  index === 4 ? "md:col-span-2" : ""
                }`}
              >
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-12 h-12 rounded-2xl bg-gradient-to-r from-red-600 to-orange-500 text-white flex items-center justify-center text-xl">
                    {item.icon}
                  </div>

                  <h3 className="text-xl font-bold text-gray-900">
                    {item.title}
                  </h3>
                </div>
                <ul className="space-y-3">
                  {item.points.map((point, i) => (
                    <li
                      key={i}
                      className="flex gap-3 text-sm text-gray-600 leading-6"
                    >
                      <span className="mt-2 w-2 h-2 rounded-full bg-red-500 shrink-0"></span>
                      {point}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
export default RulesSection;